import React, { useEffect, useState } from "react";
import { getLeaveApplications, updateLeaveStatus } from "../../api/leavesApi";
import "../../css/CustomTable.css";

export default function LeaveList() {
  const [leaves, setLeaves] = useState([]);
  const [filteredLeaves, setFilteredLeaves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusFilter, setStatusFilter] = useState("All");

  const userId = sessionStorage.getItem("userId") || 1;
  const crUser = sessionStorage.getItem("username") || "adm";

  const fetchLeaves = async () => {
    try {
      const data = await getLeaveApplications();
      setLeaves(data);
      setFilteredLeaves(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, []);

  // Filter leaves whenever the filter changes
  useEffect(() => {
    if (statusFilter === "All") {
      setFilteredLeaves(leaves);
    } else {
      setFilteredLeaves(leaves.filter(leave => leave.status === statusFilter));
    }
  }, [statusFilter, leaves]);

  const handleStatusChange = async (leaveAppID, status) => {
    try {
      const result = await updateLeaveStatus(leaveAppID, status, userId, crUser);
      alert(result.message);
      fetchLeaves(); // refresh list
    } catch (err) {
      alert("Failed to update leave status: " + err.message);
    }
  };

  if (loading) return <p>Loading leave applications...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="container-fluid p-1">
      {/* <h4 className="allowance-heading">Leave Applications</h4>

      <div className="d-flex justify-content-end mb-2">
        <label htmlFor="statusFilter" style={{ marginRight: "10px" }}>
          Filter by Status:
        </label>
        <select
          id="statusFilter"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="All">All</option>
          <option value="Pending">Pending</option>
          <option value="Approved">Approved</option>
          <option value="Rejected">Rejected</option>
        </select>
      </div> */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h4 className="allowance-heading mb-0">Leave Applications</h4>

        <div className="d-flex align-items-center">
          <label htmlFor="statusFilter" className="me-2 mb-0">
            Filter by Status:
          </label>
          <select
            id="statusFilter"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            style={{ width: "120px" }}
          >
            <option value="All">All</option>
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>
      </div>

      <div className="allowance-table-container">
        <table className="allowance-table">
          <thead>
            <tr>
              <th>Sr</th>
              <th>EmployeeCode</th>
              <th>Employee</th>
              <th>Leave Type</th>
              <th>From</th>
              <th>To</th>
              <th>Days</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredLeaves.length > 0 ? (
              filteredLeaves.map((leave, index) => (
                <tr key={leave.leaveAppID}>
                  <td>{index + 1}</td>
                  <td>{leave.employeeCode}</td>
                  <td>{leave.employeeName}</td>
                  <td>{leave.leaveName}</td>
                  <td>{new Date(leave.startDate).toLocaleDateString()}</td>
                  <td>{new Date(leave.endDate).toLocaleDateString()}</td>
                  <td>{leave.noOfDays}</td>
                  <td>{leave.status}</td>
                  <td>
                    {leave.status === "Pending" ? (
                      <>
                        <button
                          className="edit"
                          onClick={() =>
                            handleStatusChange(leave.leaveAppID, "Approved")
                          }
                          style={{ marginRight: "5px" }}
                        >
                          Approve
                        </button>
                        <button
                          className="delete"
                          onClick={() =>
                            handleStatusChange(leave.leaveAppID, "Rejected")
                          }
                        >
                          Reject
                        </button>
                      </>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No leave applications found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}




// import React, { useEffect, useState } from "react";
// import { getLeaveApplications, updateLeaveStatus } from "../../api/leavesApi";
// import "../../css/CustomTable.css";

// export default function LeaveList() {
//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Get logged-in userId from session storage
//   const userId = sessionStorage.getItem("userId") || 1; // fallback to 1 if not set
//   const crUser = sessionStorage.getItem("username") || "adm";  

//   const fetchLeaves = async () => {
//     try {
//       const data = await getLeaveApplications();
//       setLeaves(data);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLeaves();
//   }, []);

//   const handleStatusChange = async (leaveAppID, status) => {
//     try {
//       const result = await updateLeaveStatus(leaveAppID, status, userId, crUser); // pass userId and trUser
//       alert(result.message);
//       fetchLeaves(); // refresh list
//     } catch (err) {
//       alert("Failed to update leave status: " + err.message);
//     }
//   };

//   if (loading) return <p>Loading leave applications...</p>;
//   if (error) return <p>Error: {error}</p>;

//   return (
//     <div className="container-fluid p-1">
//       <h4 className="allowance-heading">Leave Applications</h4>

//       <div className="allowance-table-container">
//         <table className="allowance-table">
//           <thead>
//             <tr>
//               <th>Sr</th>
//               <th>Employee</th>
//               <th>Leave Type</th>
//               <th>From</th>
//               <th>To</th>
//               <th>Days</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {leaves.length > 0 ? (
//               leaves.map((leave, index) => (
//                 <tr key={leave.leaveAppID}>
//                   <td>{index + 1}</td>
//                   <td>{leave.employeeName}</td>
//                   <td>{leave.leaveName}</td>
//                   <td>{new Date(leave.startDate).toLocaleDateString()}</td>
//                   <td>{new Date(leave.endDate).toLocaleDateString()}</td>
//                   <td>{leave.noOfDays}</td>
//                   <td>{leave.status}</td>
//                   <td>
//                     {leave.status === "Pending" ? (
//                       <>
//                         <button
//                           className="edit"
//                           onClick={() =>
//                             handleStatusChange(leave.leaveAppID, "Approved")
//                           }
//                           style={{ marginRight: "5px" }}
//                         >
//                           Approve
//                         </button>
//                         <button
//                           className="delete"
//                           onClick={() =>
//                             handleStatusChange(leave.leaveAppID, "Rejected")
//                           }
//                         >
//                           Reject
//                         </button>
//                       </>
//                     ) : (
//                       "-"
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="text-center">
//                   No leave applications found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }



